import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './formulario.css';
import { withTranslation } from 'react-i18next';
import i18n from '../i18n';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import { withRouter, Link } from "react-router-dom";
import AlertDialog from './AlertDialog';
import queryString from "query-string";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

library.add(fab);
library.add(fas);
class FormularioWhatsapp extends React.Component {
  constructor(props) {
    super(props);
    this.alertDialogRef = React.createRef();
    this.values = queryString.parse(this.props.location.search);

    const local = JSON.parse(localStorage.getItem("id"));

    if (this.props.id !== local) {
      localStorage.clear();
    }

    this.state = {
      checkCondiciones: false,
      errorCondiciones: false,
      errorEmail: false,
      errorEmailNoValido: false,
      errorNombreNoValido: false
    };

    this.selectIdioma = this.selectIdioma.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.resetErrores = this.resetErrores.bind(this);
  }

  async getUrlWebchat(value) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify({
        param1: this.props.id,
        param2: value
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    };
    const response = await fetch("/api/urlWebchat", requestOptions);
    const result = await response.json();
    if (result.url) {
      this.setState({
        urlWebchat: result.url
      });
    }
  }

  componentDidMount() {
    if (this.values.param) {
      this.getUrlWebchat(this.values.param);
    }
  }

  resetErrores = () => {
    this.setState({
      errorCondiciones: false,
      errorEmail: false,
      errorEmailNoValido: false,
      errorNombreNoValido: false
    });
  };

  handleChange = event => {
    const { state } = this.state;
    const value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    this.setState({ ...state, [event.target.name]: value });
  };

  changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };

  selectIdioma = event => {
    i18n.changeLanguage(event.target.value);
  };

  abrirWhatsapp = async () => {
    const newWindow = window.open(
      "https://wa.me/" + this.props.telefonoWhatsapp,
      "_blank",
      "noopener,noreferrer"
    );
    if (newWindow) newWindow.opener = null;
  };

  accesoFormulario = (e) => {
    e.preventDefault();
    const { urlWebchat } = this.state;
    if (urlWebchat && this.props.logo) {
      const newWindow = window.open(urlWebchat, "_self");
      if (newWindow) newWindow.opener = null;
    } else {
      this.props.history.push("/" + this.props.id + "/acceso/");
    }
  };

  render() {
    const { t } = this.props;
    const {
      checkCondiciones,
      errorCondiciones,
      errorEmail,
      errorEmailNoValido,
      errorNombreNoValido
    } = this.state;
    return (
      <div className="login-form">
        <div className="dropdown select-idioma">
          <button className="dropbtn">{t("idioma.label")}</button>
          <div className="dropdown-content">
            <button
              className="botones-idiomas"
              value={"es"}
              onClick={this.selectIdioma}
            >
              {t("es.label")}
            </button>
            <button
              className="botones-idiomas"
              value={"en"}
              onClick={this.selectIdioma}
            >
              {t("en.label")}
            </button>
          </div>
        </div>
        <div className="clear"></div>
        <form onSubmit={this.handleSubmit} noValidate>
          {this.props.logo && (
            <img
              className="logo"
              src={
                `https://imageswfz.s3-eu-west-1.amazonaws.com/login/` +
                this.props.logo
              }
              alt="Logo"
            />
          )}
          <h4 className="modal-title">{t("necesitasAyuda.label")}</h4>
          <button
            onClick={this.abrirWhatsapp}
            disabled={!checkCondiciones}
            /* type="button" */
            className="btn btn-primary btn-block btn-lg whatsapp texto-boton"
            value={t("whatsapp.label")}
          >
            <FontAwesomeIcon
              className="icono-boton"
              icon={["fab", "whatsapp"]}
            />
            {t("whatsapp.label")}
          </button>
          <button
            /* type="submit" */
            disabled={!checkCondiciones}
            onClick={this.accesoFormulario}
            className="btn btn-primary btn-block btn-lg texto-boton"
            value={t("accede.label")}
          >
            <FontAwesomeIcon
              className="icono-boton"
              icon={["fas", "comments"]}
            />
            {t("accede.label")}
          </button>
          <FormControlLabel
            control={
              <Checkbox
                checked={checkCondiciones}
                onChange={this.handleChange}
                name="checkCondiciones"
                color="primary"
              />
            }
            className="texto-condiciones"
            label={
              <div>
                {t("acepto.label")}
                <Link
                  className="link-condiciones"
                  to={this.props.id + "/condiciones"}
                  target="_blank"
                >
                  {t("condiciones.label")}
                </Link>
                {t("y.label")}
                <Link
                  className="link-condiciones"
                  to={this.props.id + "/politica"}
                  target="_blank"
                >
                  {t("politica.label")}
                </Link>
              </div>
            }
          />
          <FormHelperText className="Mui-error mensaje-error">
            {errorCondiciones ? t("condicionesObligatorias.label") : ""}
          </FormHelperText>
          <AlertDialog
            resetErrores={this.resetErrores}
            ref={this.alertDialogRef}
            aviso={t("aviso.label")}
            aceptar={t("aceptar.label")}
            mensaje={
              errorEmail
                ? t("sinEmail.label")
                : errorEmailNoValido
                ? t("emailNoValido.label")
                : errorNombreNoValido
                ? t("nombreNoValido.label")
                : errorCondiciones
                ? t("condicionesObligatorias.label")
                : ""
            }
          />
        </form>
      </div>
    );
  }
}

export default withTranslation()(withRouter(FormularioWhatsapp));
